import {debug, pApiKey} from '../../../../config';
import {checkMethod} from '../../utils/validate';

/* eslint-disable require-jsdoc */ function getAjaxOpts(url, method, auth) {
  const opts = {};
  opts.url = url;
  const httpMethod = checkMethod(method);
  if (httpMethod == 'method issue') {
    return httpMethod;
  }
  opts.method = httpMethod;
  if (auth) {
    opts.headers = {
      Authorization: pApiKey,
    };
  }
  debug && console.log('ajax opts ', opts);
  return opts;
}
export {getAjaxOpts};
